module.exports = require("./naq-NA");